import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../assets/logo.png';
const _hoisted_1 = {
  class: "border-b border-gray-200 px-8 py-2 bg-white sticky top-0 z-50 h-12 flex items-center"
};
const _hoisted_2 = {
  class: "nav-container w-full max-w-screen-xl mx-auto flex justify-between items-center h-full min-h-10 gap-5"
};
const _hoisted_3 = {
  class: "flex flex-row items-center pl-8"
};
const _hoisted_4 = {
  class: "nav-links flex flex-row items-center gap-7 ml-8 flex-shrink-0 w-auto"
};
import { ref, onMounted, onUnmounted, inject } from 'vue';
export default {
  __name: 'Header',
  setup(__props) {
    const showMobileMenu = ref(false);
    const isDesktop = ref(window.innerWidth >= 768); // Assuming 768px as md breakpoint

    // 从App组件注入toggleAICopilot方法
    const toggleAICopilot = inject('toggleAICopilot');
    const checkScreenWidth = () => {
      isDesktop.value = window.innerWidth >= 768;
      if (isDesktop.value && showMobileMenu.value) {
        showMobileMenu.value = false; // Close mobile menu if resized to desktop
      }
    };
    onMounted(() => {
      window.addEventListener('resize', checkScreenWidth);
      console.log('Header mounted, toggleAICopilot available:', !!toggleAICopilot);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenWidth);
    });
    const closeMenu = () => {
      showMobileMenu.value = false;
    };
    const handleNavClick = () => {
      closeMenu();
    };
    const toggleMenu = () => {
      showMobileMenu.value = !showMobileMenu.value;
    };
    const handleAICopilotClick = () => {
      console.log('AI Copilot button clicked');
      if (toggleAICopilot) {
        console.log('Calling toggleAICopilot');
        toggleAICopilot();
      } else {
        console.log('toggleAICopilot not found');
      }
      console.log('Button click handled');
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/",
        class: "nav-brand-link no-underline flex-shrink-0 w-auto",
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
          class: "nav-brand flex items-center gap-1 flex-shrink-0"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: "SonglinAI",
          class: "logo-image w-7 h-7 object-contain"
        }), _createElementVNode("div", {
          class: "logo-text flex items-center gap-1"
        }, [_createElementVNode("span", {
          class: "text-base font-bold text-gray-800"
        }, "StockAI")])], -1)]))]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        to: "/sameboard",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/sameboard'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-chart-column mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M3 3v16a2 2 0 0 0 2 2h16"
        }), _createElementVNode("path", {
          d: "M18 17V9"
        }), _createElementVNode("path", {
          d: "M13 17V5"
        }), _createElementVNode("path", {
          d: "M8 17v-3"
        })], -1), _createTextVNode(" 最强 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/dahai",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/dahai'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-waves mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
        }), _createElementVNode("path", {
          d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
        }), _createElementVNode("path", {
          d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
        })], -1), _createTextVNode(" 大海 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/fenglang",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/fenglang'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-wind mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"
        }), _createElementVNode("path", {
          d: "M9.6 4.6A2 2 0 1 1 11 8H2"
        }), _createElementVNode("path", {
          d: "M12.6 19.4A2 2 0 1 0 14 16H2"
        })], -1), _createTextVNode(" 风浪 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/bigfish",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/bigfish'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-compass mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"
        }), _createElementVNode("circle", {
          cx: "12",
          cy: "12",
          r: "10"
        })], -1), _createElementVNode("span", {
          class: "nav-live"
        }, [_createTextVNode("海域"), _createElementVNode("i", {
          class: "live-corner"
        })], -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/jijing",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/jijing'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-fish mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6-3.56 0-7.56-2.53-8.5-6Z"
        }), _createElementVNode("path", {
          d: "M18 12v.5"
        }), _createElementVNode("path", {
          d: "M16 17.93a9.77 9.77 0 0 1 0-11.86"
        }), _createElementVNode("path", {
          d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33"
        })], -1), _createTextVNode(" 巨鲸 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/pool",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/pool'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
          class: "mr-1.5 h-4 w-4",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "currentColor"
        }, [_createElementVNode("path", {
          d: "M160 196.352c35.712-9.856 72.704-3.584 117.824 24.96 3.584 2.496 13.312 7.04 24.832 9.408 18.112 3.712 35.776 1.28 53.376-9.856a183.552 183.552 0 0 1 196.608 0.448c3.52 2.496 13.312 7.04 24.768 9.408 18.176 3.712 35.84 1.28 53.376-9.856a183.616 183.616 0 0 1 196.672 0.512c1.408 0.96 7.936 7.04 9.408 8 6.272 4.096 13.952 5.12 27.136-1.152v59.904a87.808 87.808 0 0 1-65.024-12.608c-6.336-4.16-12.672-9.856-10.88-8.96a114.24 114.24 0 0 0-120 0.832 139.264 139.264 0 0 1-105.088 19.072 141.44 141.44 0 0 1-48.512-19.136 114.24 114.24 0 0 0-121.152 0 139.264 139.264 0 0 1-105.152 19.2 141.312 141.312 0 0 1-48.384-19.2c-34.304-21.632-53.76-22.656-79.808-8.32v-62.656z m0 269.888v-62.72c35.712-9.856 72.704-3.584 117.824 24.96 3.584 2.496 13.312 7.04 24.832 9.344 18.112 3.84 35.776 1.28 53.376-9.792a183.552 183.552 0 0 1 196.608 0.448c3.52 2.496 13.312 7.04 24.768 9.344 18.176 3.84 35.84 1.28 53.376-9.792a183.616 183.616 0 0 1 196.672 0.448c1.408 1.024 7.936 7.04 9.408 8.064 6.272 4.096 13.952 5.056 27.136-1.152v59.904a87.808 87.808 0 0 1-65.024-12.608c-6.336-4.16-12.672-9.856-10.88-8.96a114.24 114.24 0 0 0-120 0.832 139.264 139.264 0 0 1-105.088 19.072 141.44 141.44 0 0 1-48.512-19.2 114.24 114.24 0 0 0-121.152 0.128 139.264 139.264 0 0 1-105.152 19.072 141.312 141.312 0 0 1-48.384-19.072c-34.304-21.76-53.76-22.72-79.808-8.32z m0 207.104v-62.656c35.712-9.92 72.704-3.648 117.824 24.96 3.584 2.432 13.312 6.976 24.832 9.344 18.112 3.776 35.776 1.28 53.376-9.792a183.552 183.552 0 0 1 196.608 0.448c3.52 2.432 13.312 6.976 24.768 9.344 18.176 3.776 35.84 1.28 53.376-9.792a183.616 183.616 0 0 1 196.672 0.448c1.408 1.024 7.936 7.04 9.408 8 6.272 4.16 13.952 5.12 27.136-1.088v59.904a87.808 87.808 0 0 1-65.024-12.672c-6.336-4.16-12.672-9.856-10.88-8.96a114.24 114.24 0 0 0-120 0.832A139.264 139.264 0 0 1 563.008 700.8a141.44 141.44 0 0 1-48.512-19.2 114.24 114.24 0 0 0-121.152 0.064A139.264 139.264 0 0 1 288.192 700.8a141.312 141.312 0 0 1-48.384-19.136c-34.304-21.696-53.76-22.656-79.808-8.32zM0 128h64v704a32 32 0 0 0 32 32h832a32 32 0 0 0 32-32V128h64v704a96 96 0 0 1-96 96H96a96 96 0 0 1-96-96V128z"
        })], -1), _createTextVNode(" 小鱼 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/guanshi",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/guanshi'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-candlestick-chart mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M5 2v20"
        }), _createElementVNode("path", {
          d: "M19 6v12"
        }), _createElementVNode("rect", {
          x: "2",
          y: "6",
          width: "6",
          height: "12",
          rx: "1"
        }), _createElementVNode("rect", {
          x: "16",
          y: "2",
          width: "6",
          height: "6",
          rx: "1"
        }), _createElementVNode("rect", {
          x: "16",
          y: "16",
          width: "6",
          height: "6",
          rx: "1"
        })], -1), _createTextVNode(" 观势 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/redian",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/redian'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-flame mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("path", {
          d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
        })], -1), _createTextVNode(" 热点 ", -1)]))]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        to: "/youzi",
        class: _normalizeClass(["flex items-center text-gray-700 no-underline p-0 relative transition-colors duration-200 font-medium text-sm border-b-2 border-transparent h-full box-boxer hover:text-blue-600", {
          'text-blue-500': _ctx.$route.path === '/youzi'
        }]),
        onClick: handleNavClick
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: "lucide lucide-crosshair mr-1.5 h-4 w-4",
          "aria-hidden": "true"
        }, [_createElementVNode("circle", {
          cx: "12",
          cy: "12",
          r: "10"
        }), _createElementVNode("path", {
          d: "m22 12h-4"
        }), _createElementVNode("path", {
          d: "m6 12h-4"
        }), _createElementVNode("path", {
          d: "m12 6v-4"
        }), _createElementVNode("path", {
          d: "m12 22v-4"
        })], -1), _createElementVNode("span", {
          class: "nav-live"
        }, [_createTextVNode("游资"), _createElementVNode("i", {
          class: "live-corner"
        })], -1)]))]),
        _: 1
      }, 8, ["class"])])]), _createElementVNode("div", {
        class: "flex items-center gap-4"
      }, [_createElementVNode("button", {
        class: "ai-block-btn flex items-center gap-1 px-4 py-2",
        onClick: handleAICopilotClick
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("div", {
        class: "ai-block-icon"
      }, "AI", -1), _createElementVNode("span", null, "资管助手", -1)]))]), _createElementVNode("button", {
        class: "nav-toggle hidden flex-col justify-around w-8 h-8 bg-transparent border-none cursor-pointer p-0 z-20 md:hidden",
        onClick: toggleMenu,
        "aria-label": "Toggle navigation"
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("span", {
        class: "bar w-8 h-0.5 bg-gray-800 rounded-full transition-all duration-300 ease-linear relative"
      }, null, -1), _createElementVNode("span", {
        class: "bar w-8 h-0.5 bg-gray-800 rounded-full transition-all duration-300 ease-linear relative"
      }, null, -1), _createElementVNode("span", {
        class: "bar w-8 h-0.5 bg-gray-800 rounded-full transition-all duration-300 ease-linear relative"
      }, null, -1)]))])])]), showMobileMenu.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mobile-menu-mask fixed inset-0 bg-black bg-opacity-15 z-40",
        onClick: closeMenu
      })) : _createCommentVNode("", true)]);
    };
  }
};